import { useTranslation } from "react-i18next";
import { Badge } from "../ui/badge";
import { formatMin } from "../../utils/saferoute";

export default function SafeRouteOptions({ routes, recommendedIndex }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-1">
      {routes.map((r) => {
        const isRec = r.index === recommendedIndex;
        return (
          <div
            key={r.index}
            className={`flex items-center gap-2 text-[11px] rounded-sm px-2 py-1.5 ${
              isRec ? "bg-emerald-50 border border-emerald-200" : "bg-gray-50 border border-gray-100"
            }`}
            data-testid={`safe-route-option-${r.index}`}
          >
            <span className={`font-bold ${isRec ? "text-emerald-700" : "text-gray-700"}`}>
              {isRec ? "★" : `${r.index + 1}.`}
            </span>
            <span className="font-body text-gray-800 truncate flex-1">{t("safe_route.via")} {r.summary}</span>
            <span className="font-mono text-gray-700">{formatMin(r.traffic_min)}</span>
            <span className="text-gray-400">·</span>
            <span className="font-mono text-gray-500">{r.distance_km} km</span>
            {r.alerts.length > 0 && (
              <Badge className="bg-red-100 text-red-800 hover:bg-red-100 text-[9px] rounded-sm px-1 py-0 ml-1">
                {t("safe_route.alerts_one", { count: r.alerts.length, defaultValue: t("safe_route.alerts_other", { count: r.alerts.length }) })}
              </Badge>
            )}
          </div>
        );
      })}
    </div>
  );
}
